<template>
  <li :class="{ top: root }">
    <section class="folder">
      <template v-if="!root">
        <span
          class="plus-minus"
          v-if="hasSubFolders && isExpanded"
          @click="toggle"
        >
          <img src="../../../images/icons/minus-regular.svg" />
        </span>
        <span
          class="plus-minus"
          v-else-if="hasSubFolders && !isExpanded"
          @click="toggle"
        >
          <img src="../../../images/icons/plus-regular.svg" />
        </span>
        <span class="plus-minus" v-else />
      </template>

      <img
        @click="triggerSelect"
        class="folder-icon"
        src="../../../images/icons/folder.svg"
      />
      <span @click="triggerSelect" :class="{ selected: selected }">{{
        folder.name
      }}</span>
    </section>
    <ul v-show="isExpanded">
      <folder-leaf
        v-for="(subFolder, index) in folder.subFolders"
        :key="index"
        :folder="subFolder"
      ></folder-leaf>
    </ul>
  </li>
</template>

<script>
import { mapStores } from 'pinia'
import { useFileStoreStore } from '@/features/filestore/FileStore.store'

export default {
  name: 'FolderLeaf',
  props: {
    folder: Object,
    expanded: {
      type: Boolean,
      default: false
    },
    root: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isExpanded: this.expanded
    }
  },
  computed: {
    hasSubFolders() {
      return this.folder.subFolders && this.folder.subFolders.length > 0
    },
    ...mapStores(useFileStoreStore),
    selected() {
      return (
        this.fileStoreStore.treeBrowserSelectedFolderId === this.folder.folderId
      )
    }
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded
    },
    triggerSelect() {
      this.fileStoreStore.treeBrowserSelectedFolderId = this.folder.folderId
    }
  }
}
</script>

<style scoped lang="scss">
.top {
  > ul {
    padding-left: 0;
  }
}
.folder {
  cursor: pointer;
  display: flex;
  align-items: center;
  height: 36px;
  padding-left: 2px;
  transition: all 0.4s;

  .plus-minus {
    width: 13px;
    height: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    min-width: 13px;
    flex-grow: 0;
  }

  .folder-icon {
    margin-right: 10px;
    min-width: 15px;
  }

  .selected {
    color: var(--sub-color);
    font-weight: 600;
  }

  span {
    white-space: nowrap;
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    flex-grow: 1;
  }
}

ul {
  padding-left: 24px;
  line-height: 1.5em;
  list-style-type: none;
}
</style>
